import { Tabs, Button, Checkbox, TextField } from '@shopify/polaris';
import { Popover } from '@superops/ui-design-system';
import { useQuery, useMutation } from '@apollo/client';
import React, { useCallback, useState, useEffect } from 'react';
import styled from 'styled-components';
import { Stopwatch } from '@styled-icons/fa-solid/Stopwatch';
import { cloneDeep, pick, includes } from 'lodash';
import { ShoppingCart } from '@styled-icons/fa-solid/ShoppingCart';
import { Close } from '@styled-icons/evaicons-solid';
import { Clock } from '@styled-icons/fa-solid/Clock';
import { PauseCircle } from '@styled-icons/fa-solid/PauseCircle';
import { StopCircle } from '@styled-icons/fa-solid/StopCircle';
import {
  GET_WHITELISTED_OFFERINGS,
  AccountClient,
  CREATE_WORKLOG,
  CREATE_WORKLOG_TIMER,
  UPDATE_WORKLOG_TIMER,
  GET_WORKLOG_TIMERS
} from '@nile/graphql';
import {
  DropdownIndicator,
  formatGroupLabel,
  IndicatorSeparator
} from '@nile/components/src/Pebbles/select';
import {
  getParsedCrudData,
  getTranslatedText,
  BackgroundIcon,
  EventEmitter,
  toast,
  TEXT_LENGTH
} from '@nile/components';
import Select from 'react-select';
import Timer from 'react-compound-timer';

import { FormattedMessage, injectIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';

const CloseIcon = styled(Close)`
  min-width: 16px;
  min-height: 16px;
  width: 16px;
  height: 16px;
  color: black;
  cursor: pointer;
`;

const Shopping = styled(ShoppingCart)`
  min-width: 16px;
  min-height: 16px;
  width: 16px;
  height: 16px;
  color: #999999;
`;

const WorklogWrapper = styled.div`
  padding: 12px;
  min-width: 700px;
  .Polaris-Button--plain {
    padding: 0px !important;
    margin: 0 !important;
  }
`;

const ItemWrap = styled.div`
  display: flex;
  align-items: center;
  .Polaris-TextField {
    margin-bottom: 0px !important;
    max-width: 40px !important;
    margin-right: 8px;
  }
  .quantity .Polaris-TextField {
    max-width: 100px !important;
  }
`;

const ActionButtons = styled.div`
  .Polaris-Button {
    min-height: 2.6rem;
    height: 35px;
    border-radius: 50%;
    padding: 0 !important;
  }
`;

function WorklogContainer(props) {
  const { intl } = props;
  const { client } = props.ticket;
  const [popoverActive, setPopoverActive] = useState(false);
  const [allOfferings, setAllOfferings] = useState([]);
  const { loading, data, error } = useQuery(GET_WHITELISTED_OFFERINGS, {
    client: AccountClient,
    variables: {
      listInfo: {
        page: 1,
        pageSize: 10
      },
      clientId: client.accountId
    },
    onCompleted(res) {
      setAllOfferings(res?.getWhiteListedClientOfferings?.offerings || []);
    }
  });
  const [createWorklogTimer] = useMutation(CREATE_WORKLOG_TIMER);
  const [updateWorklogTimer] = useMutation(UPDATE_WORKLOG_TIMER);
  const togglePopoverActive = useCallback(
    () => setPopoverActive((active) => !active),
    []
  );

  const createWorklogTimerAction = (params, callback) => {
    createWorklogTimer({
      variables: {
        ticketId: props.ticket.ticketId,
        worklogTimer: params.timerInput
      },
      input: {
        worklogTimer: params.timerInput
      }
    }).then((res) => {
      if (callback && res?.data?.createWorklogTimer) {
        callback(res.data.createWorklogTimer);
      }
    });
  };

  const updateWorklogTimerAction = (params, callback) => {
    updateWorklogTimer({
      variables: {
        timerId: params.timerId,
        worklogTimer: params.timerInput
      },
      input: {
        worklogTimer: params.timerInput
      }
    }).then((res) => {
      if (callback && res?.data?.updateWorklogTimer) {
        callback(res.data.updateWorklogTimer);
      }
    });
  };

  const actions = {
    createWorklogTimer: createWorklogTimerAction,
    updateWorklogTimer: updateWorklogTimerAction
  };

  const activator = (
    <Button onClick={togglePopoverActive}>
      <div className="fx center">
        <SVGIcon name="Worklog" />
      </div>
    </Button>
  );

  return (
    <div className="vignesh">
      <Popover
        active={popoverActive}
        activator={activator}
        onClose={() => {
          return;
        }}
        preferredAlignment="right"
      >
        <Worklog
          intl={intl}
          togglePopoverActive={togglePopoverActive}
          allOfferings={allOfferings}
          id={props.id}
          actions={actions}
          ticket={props.ticket}
        />
      </Popover>
    </div>
  );
}

function Worklog(props) {
  const { intl } = props;
  const {
    loading: timerLoading,
    data: allTimers,
    error: timerError
  } = useQuery(GET_WORKLOG_TIMERS, {
    variables: {
      ticketId: props.ticket.ticketId
    },
    fetchPolicy: 'network-only',
    onCompleted(res) {
      setItems(
        res.getWorklogTimers.map((el) => {
          return {
            ...el,
            itemId: el.offering.offeringId
          };
        })
      );
    }
  });
  const [items, setItems] = useState([]);
  const [referenceItems, setReferenceItems] = useState([]);
  const [notes, setNotes] = useState('');
  const [resetTimer, setResetTimer] = useState(false);
  const [addItems, setAddItems] = useState([]);
  const [updateItems, setupdateItems] = useState([]);
  const [deleteItems, setdeleteItems] = useState([]);
  const { allOfferings, id } = props;
  const [createWorklog] = useMutation(CREATE_WORKLOG);
  useEffect(() => {
    if (resetTimer) {
      addWorklog();
    }
  }, [resetTimer]);
  if (timerLoading) return <div>loading...</div>;
  const addItem = () => {
    const allItems = cloneDeep(items);
    const updatedaddItems = cloneDeep(addItems);
    allItems.push({
      itemId: '',
      offering: '',
      billable: false,
      quantity: null
    });
    setItems(allItems);
  };
  const refreshItem = (item) => {
    const allItems = cloneDeep(items);
    const index = allItems.findIndex(
      (el) => el.offering.offeringId === item.offering.offeringId
    );
    allItems[index] = { ...item, itemId: item.offering.offeringId };
    setItems(allItems);
  };
  const createWorklogTimerAction = (params) => {
    props.actions.createWorklogTimer(params, refreshItem);
  };
  const updateWorklogTimerAction = (params) => {
    props.actions.updateWorklogTimer(params, refreshItem);
  };
  const actions = {
    createWorklogTimer: createWorklogTimerAction,
    updateWorklogTimer: updateWorklogTimerAction
  };
  const updateItem = (item, field, value) => {
    const allItems = cloneDeep(items);
    const allItemIndex = items.findIndex(
      (el) => el.offering?.offeringId === item.offering?.offeringId
    );
    if (allItemIndex > -1) {
      allItems[allItemIndex][field] = value;
    }
    setItems(allItems);
  };
  const addWorklog = () => {
    const reqItems = items
      .filter((el) => !el.timerId || (el.timerId && el.state === 'STOPPED'))
      .map((el) => {
        return {
          ...el,
          offeringId: el.offering.offeringId
        };
      });
    const baseObj = referenceItems.map((el) => {
      return {
        ...el,
        offeringId: el.offering.offeringId
      };
    });
    const parsedObject = getParsedCrudData(baseObj, reqItems, 'offeringId');
    const newAddedItems = parsedObject.addedItems;
    const addedItems = newAddedItems.map((el) => {
      return {
        billable: el.billable,
        quantity: el.quantity || el.timespent || 0,
        offering: pick(el.offering, ['offeringId', 'name'])
      };
    });
    props.togglePopoverActive();
    createWorklog({
      variables: {
        ticketId: id,
        worklog: {
          notes: notes,
          addItems: addedItems,
          resetTimer: resetTimer
        }
      },
      input: {
        worklog: {
          notes: notes,
          addItems: addedItems,
          resetTimer: resetTimer
        }
      }
    }).then((res) => {
      if (res?.data?.createWorklog) {
        EventEmitter.dispatch('worklogChange');
        toast('success', 'New log created successfully');
      } else {
        // toast('error', 'Something went wrong');
      }
    });
  };
  const resetTimerBool = () => {
    setResetTimer(true);
  };
  const hasTimers = items.some(
    (el) => el.timerId && includes(['RUNNING', 'PAUSED'], el.state)
  );
  return (
    <WorklogWrapper>
      <div className="bold flex">
        <FormattedMessage id="ticket.details.worklog.header" />
        <div className="mlauto mr8" onClick={props.togglePopoverActive}>
          <CloseIcon />
        </div>
      </div>
      {items.map((item) => {
        return (
          <Item
            intl={intl}
            item={item}
            allOfferings={allOfferings}
            updateItem={updateItem}
            actions={actions}
            allItems={items}
          />
        );
      })}
      <div className="mt10">
        <Button plain onClick={addItem}>
          <FormattedMessage id="ticket.details.worklog.newItem" />
        </Button>
      </div>
      <div className="mt10">
        <TextField
          label=""
          placeholder={getTranslatedText(intl, 'ticket.details.worklog.pl')}
          value={notes}
          onChange={(val) => setNotes(val)}
          multiline={3}
          maxLength={TEXT_LENGTH.size_9}
        />
      </div>
      <div className="flex">
        <div className="mlauto">
          {hasTimers ? (
            <Button
              primary
              onClick={addWorklog}
              connectedDisclosure={{
                accessibilityLabel: 'Other save actions',
                actions: [
                  {
                    content: (
                      <div onClick={resetTimerBool}>
                        <FormattedMessage id="ticket.details.worklog.stopTimer" />
                      </div>
                    )
                  }
                ]
              }}
            >
              <FormattedMessage id="ticket.details.worklog.addWorklog" />
            </Button>
          ) : (
            <Button primary onClick={addWorklog}>
              <FormattedMessage id="ticket.details.worklog.addWorklog" />
            </Button>
          )}
        </div>
      </div>
    </WorklogWrapper>
  );
}

function Item(props) {
  const { intl, item, allOfferings, actions, allItems } = props;
  console.log(item);
  const handleBillableChange = useCallback((newChecked) => {
    props.updateItem(item, 'billable', newChecked);
  });
  const handleOfferingChange = (val) => {
    props.updateItem(item, 'offering', val);
  };
  const handleQuantityChange = (val) => {
    props.updateItem(item, 'quantity', val);
  };
  const options = allOfferings.map((el) => {
    return {
      ...el,
      name: el.name,
      label: el.name,
      value: el.name
    };
  });
  const startTimer = () => {
    props.actions.createWorklogTimer({
      timerInput: {
        offering: {
          offeringId: item?.offering.offeringId,
          name: item?.offering.name
        },
        billable: !!item?.billable
      }
    });
  };
  const updateTimer = (event) => {
    props.actions.updateWorklogTimer({
      timerInput: {
        offering: {
          offeringId: item?.offering.offeringId,
          name: item?.offering.name
        },
        billable: !!item?.billable,
        event: event
      },
      timerId: item.timerId
    });
  };

  const renderActionButtons = (
    selectedItem,
    getTimerState,
    resume,
    pause,
    stop,
    start,
    reset,
    timerState
  ) => {
    if (selectedItem.state) {
      switch (selectedItem.state) {
        case 'RUNNING':
          return (
            <div className="flex">
              <div className="ml8">
                <Button onClick={pause}>
                  <div className="fx center">
                    <SVGIcon name="PausePlain" size="xs" color="#333333" />
                  </div>
                </Button>
              </div>
              <div className="ml8">
                <Button onClick={stop}>
                  <div className="fx center">
                    <SVGIcon name="Stop" size="xs" />
                  </div>
                </Button>
              </div>
            </div>
          );
        case 'PAUSED':
          return (
            <div className="flex">
              <div className="ml8">
                <Button onClick={resume}>
                  <div className="fx center">
                    <SVGIcon name="Play" size="xs" />
                  </div>
                </Button>
              </div>
              <div className="ml8">
                <Button onClick={stop}>
                  <div className="fx center">
                    <SVGIcon name="Stop" size="xs" />
                  </div>
                </Button>
              </div>
            </div>
          );
        default:
          return '';
      }
    } else {
      switch (getTimerState()) {
        case 'PLAYING':
          return (
            <div className="flex">
              <div className="ml8">
                <Button onClick={pause}>
                  <div className="fx center">
                    <SVGIcon name="PausePlain" size="xs" color="#333333" />
                  </div>
                </Button>
              </div>
              <div className="ml8">
                <Button onClick={stop}>
                  <div className="fx center">
                    <SVGIcon name="Stop" size="xs" />
                  </div>
                </Button>
              </div>
            </div>
          );
        case 'PAUSED':
          return (
            <>
              <div className="ml8">
                <Button onClick={resume}>
                  <div className="fx center">
                    <SVGIcon name="Play" size="xs" />
                  </div>
                </Button>
              </div>
              <div className="ml8">
                <Button onClick={stop}>
                  <div className="fx center">
                    <SVGIcon name="Stop" size="xs" />
                  </div>
                </Button>
              </div>
            </>
          );
        case 'INITED':
          return (
            <>
              <Button onClick={start}>
                <div className="fx center">
                  <SVGIcon name="Play" size="xs" />
                </div>
              </Button>
            </>
          );
        default:
          return '';
      }
    }
  };
  const getHours = (duration) => {
    const hours = Math.floor(duration / (1000 * 60 * 60));

    return hours;
  };
  const getMinutes = (duration) => {
    const minutes = Math.round((duration / (1000 * 60)) % 60);
    return minutes;
  };
  const handleDurationChange = (type, val, totalTime) => {
    const minutes = getMinutes(totalTime);
    const hours = getHours(totalTime);
    let updatedQuantity = hours * 60 + minutes;
    switch (type) {
      case 'hours':
        updatedQuantity = Number(val) * 60 + minutes;
        break;
      case 'minutes':
        updatedQuantity = Number(hours) * 60 + Number(val);
        break;
      default:
        break;
    }
    props.updateItem(item, 'quantity', updatedQuantity);
  };
  const renderQuantity = (selectedItem) => {
    if (selectedItem?.offering?.type === 'SERVICE') {
      return (
        <Timer
          initialTime={
            Number(selectedItem?.quantity) * 60000 ||
            selectedItem?.timespent * 60000 ||
            0
          }
          startImmediately={selectedItem.state === 'RUNNING' || false}
          lastUnit="h"
          onStart={() => startTimer()}
          onResume={() => updateTimer('RESUME')}
          onPause={() => updateTimer('PAUSE')}
          onStop={() => updateTimer('STOP')}
          onReset={() => console.log('onReset hook')}
        >
          {(params) => {
            const {
              start,
              resume,
              pause,
              stop,
              reset,
              timerState,
              getTimerState,
              getTime
            } = params;
            const runTime = getTime();
            console.log(runTime);
            return (
              <>
                <div className="flex center">
                  <div className="fx center ml8">
                    <SVGIcon name="Worklog" />
                  </div>
                  <div className="flex center ml8 mr8">
                    {(timerState === 'STOPPED' || timerState === 'INITED') &&
                    selectedItem.state !== 'RUNNING' ? (
                      <TextField
                        value={
                          selectedItem?.quantity >= 0
                            ? getHours(
                                selectedItem.quantity * 60000
                              )?.toString()
                            : getHours(getTime())?.toString()
                        }
                        onChange={(val) => {
                          handleDurationChange(
                            'hours',
                            val,
                            selectedItem?.quantity >= 0
                              ? selectedItem.quantity * 60000
                              : getTime()
                          );
                        }}
                        type="number"
                      />
                    ) : (
                      <div className="mr4">
                        <Timer.Hours />
                      </div>
                    )}
                    <FormattedMessage id="ticket.details.worklog.hrs" />
                  </div>
                  <div className="flex center mr8">
                    {(timerState === 'STOPPED' || timerState === 'INITED') &&
                    selectedItem.state !== 'RUNNING' ? (
                      <TextField
                        value={
                          selectedItem?.quantity >= 0
                            ? getMinutes(
                                selectedItem.quantity * 60000
                              )?.toString()
                            : getMinutes(getTime())?.toString()
                        }
                        onChange={(val) => {
                          handleDurationChange(
                            'minutes',
                            val,
                            selectedItem?.quantity >= 0
                              ? selectedItem.quantity * 60000
                              : getTime()
                          );
                        }}
                        type="number"
                      />
                    ) : (
                      <div className="mr4">
                        <Timer.Minutes />
                      </div>
                    )}
                    <FormattedMessage id="ticket.details.worklog.min" />
                  </div>
                  {/* <div className="flex center mr8">
                    <div className="mr4">
                      <Timer.Seconds />
                    </div>
                    <FormattedMessage id="ticket.details.worklog.sec" />
                  </div> */}
                </div>
                <br />
                <ActionButtons>
                  {renderActionButtons(
                    selectedItem,
                    getTimerState,
                    resume,
                    pause,
                    stop,
                    start,
                    reset,
                    timerState
                  )}
                </ActionButtons>
              </>
            );
          }}
        </Timer>
      );
    }
    if (selectedItem?.offering) {
      return (
        <div className="quantity">
          <TextField
            value={item.quantity}
            placeholder={getTranslatedText(
              intl,
              'ticket.details.worklog.quantity'
            )}
            maxLength={10}
            onChange={handleQuantityChange}
            type="number"
          />
        </div>
      );
    }
    return '';
  };
  return (
    <ItemWrap>
      <Shopping className="mr8" />
      <div className="mr8">
        <Select
          className="rule-fields"
          value={options.find(
            (el) => el.offeringId === item?.offering?.offeringId
          )}
          onChange={handleOfferingChange}
          classNamePrefix="value_selector"
          formatGroupLabel={formatGroupLabel}
          components={{ IndicatorSeparator, DropdownIndicator }}
          options={options.filter((el) => {
            return !allItems.some(
              (o) => o.offering && o.offering.offeringId === el.offeringId
            );
          })}
          menuPortalTarget={document.body}
          menuPlacement="auto"
          closeMenuOnScroll={(e) => {
            return (
              e.target &&
              e.target.classList &&
              !(e.target.classList.value.indexOf('menu-list') > -1)
            );
          }}
          name="valueselector"
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menu: (base) => ({ ...base, zIndex: 9999 })
          }}
        />
      </div>
      <div className="mr8">
        <Checkbox
          label={getTranslatedText(intl, 'ticket.details.worklog.billable')}
          checked={item.billable}
          onChange={handleBillableChange}
        />
      </div>
      {renderQuantity(item)}
    </ItemWrap>
  );
}

export default injectIntl(WorklogContainer);
